<template>
    <v-navigation-drawer
        hide-overlay
        app
        right
        temporary
        :value="isOpen"
        @input="onChange"
        width="75%"
    >
        <v-list dense class="pa-0">
            <v-list-item two-line class="px-5 mb-0" :to="{ name: 'profile' }">
                <user-avatar type="list" :user="user"></user-avatar>
                <v-list-item-content>
                    <v-list-item-title>{{
                        $vuetify.lang.t('$vuetify.pages.profile')
                    }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <template v-for="(item, index) in menu">
                <!-- divider -->
                <v-divider
                    v-if="item.is === 'divider'"
                    class="mb-0"
                ></v-divider>

                <!-- button -->
                <v-list-item
                    v-else-if="item.is === 'button'"
                    :key="index"
                    @click="item.click"
                    :disabled="item.loading"
                    class="px-5 mb-0"
                >
                    <v-list-item-icon class="my-2 mr-3">
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $vuetify.lang.t(item.name)
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- link -->
                <v-list-item v-else :key="index" :to="item.to" class="px-5">
                    <v-list-item-icon class="my-2 mr-3">
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $vuetify.lang.t(item.name)
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-list>
        <div class="mt-5 ml-6" v-if="platform === 'web'">
            <a :href="appstoreLink" target="_blank">
                <v-img
                    src="../../assets/images/appstore.svg"
                    aspect-ratio="3.3"
                    max-height="33px"
                    contain
                    position="left"
                    class="mb-2"
                ></v-img>
            </a>
            <a :href="playstoreLink" target="_blank">
                <v-img
                    src="../../assets/images/playstore.svg"
                    aspect-ratio="3.3"
                    max-height="33px"
                    contain
                    position="left"
                ></v-img>
            </a>
        </div>
    </v-navigation-drawer>
</template>
<script>
// 3rd
import { mapActions } from 'vuex';

// models
import { User } from '../../models';

// components
import UserAvatar from '../UserAvatar';
// utils
import {
    LOADER_SUBMIT_LOGOUT,
    ROUTE_LOGIN,
    ROUTE_CONTACT,
    ROUTE_STATIC_PAGE,
    ROUTE_MY_ORDERS,
    ROUTE_WISHLIST
} from '../../utils/constants';
import { evaluatePlatform, logOutUser, redirect } from '../../utils/helper';
import env from '../../utils/env';

export default {
    name: 'app-sidebar',
    components: {
        UserAvatar
    },
    props: {
        isOpen: {
            default: false
        },
        user: {}
    },
    computed: {
        whileLogout() {
            return this.$wait.is(LOADER_SUBMIT_LOGOUT);
        },
        appstoreLink() {
            return env('appstore-link');
        },
        playstoreLink() {
            return env('playstore-link');
        },
        platform() {
            return evaluatePlatform();
        }
    },
    methods: {
        ...mapActions(['openSidebar', 'closeSidebar']),
        onChange(e) {
            if (!e) {
                this.closeSidebar();
            } else {
                this.openSidebar();
            }
        },
        async logout() {
            const logout = await User.logout().catch(console.error);
            if (!logout) return;

            logOutUser();
            redirect(ROUTE_LOGIN);
        }
    },
    data() {
        return {
            menu: [
                {
                    icon: 'mdi-heart-outline',
                    name: '$vuetify.pages.wishlist',
                    desc: '$vuetify.pages.wishlist',
                    to: { name: ROUTE_WISHLIST }
                },
                {
                    icon: 'mdi-package-variant-closed',
                    name: '$vuetify.pages.my_orders',
                    desc: '$vuetify.pages.my_orders',
                    to: { name: ROUTE_MY_ORDERS }
                },
                {
                    is: 'divider'
                },
                /*
                    {
                        icon: 'mdi-lightbulb-on-outline',
                        name: '$vuetify.pages.jump_start',
                        desc: '$vuetify.pages.jump_start',
                        to: { name: ROUTE_STATIC_PAGE, params: { slug: 'intro' } },
                    },
                    */
                {
                    icon: 'mdi-database',
                    name: '$vuetify.pages.game_rules_and_collect_points',
                    to: { name: ROUTE_STATIC_PAGE, params: { slug: 'rules' } }
                },
                {
                    icon: 'mdi-star',
                    name: '$vuetify.pages.rank',
                    to: { name: ROUTE_STATIC_PAGE, params: { slug: 'rank' } }
                },
                {
                    icon: 'mdi-information-outline',
                    name: '$vuetify.pages.conditions_of_participation',
                    to: { name: ROUTE_STATIC_PAGE, params: { slug: 'terms' } }
                },
                {
                    is: 'divider'
                },
                {
                    icon: 'mdi-shield-outline',
                    name: '$vuetify.pages.data_protection',
                    to: {
                        name: ROUTE_STATIC_PAGE,
                        params: { slug: 'data_protection' }
                    }
                },
                {
                    icon: 'mdi-card-text-outline',
                    name: '$vuetify.pages.imprint',
                    to: { name: ROUTE_STATIC_PAGE, params: { slug: 'imprint' } }
                },
                {
                    icon: 'mdi-email-edit-outline',
                    name: '$vuetify.pages.contact',
                    to: { name: ROUTE_CONTACT }
                },
                {
                    is: 'divider'
                },
                {
                    icon: 'mdi-logout-variant',
                    is: 'button',
                    name: '$vuetify.buttons.logout',
                    click: this.logout,
                    loading: this.whileLogout
                },
                {
                    is: 'divider'
                }
            ]
        };
    }
};
</script>
